import { useEffect } from "react";

import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";

import { useWorker } from "../useWorker";

export const useTrackIsMarketMaker = () => {
  const { worker, isWorkerReady } = useWorker();
  const { hasEarlyAccessVip } = useUserScopes();

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({ isMarketMaker: hasEarlyAccessVip });
  }, [hasEarlyAccessVip, worker, isWorkerReady]);
};
